module.exports = __webpack_public_path__ + "media/images/wfc/venue-3-5f98152d4f0478e5ce0d49207fc54bbf.jpg";